import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import MasterListPage from "./MasterListPage";
import ActionDropdown from "Common/ActionDropdown/ActionDropdown";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { handleProductEnquiryStatus } from "slices/enquiry/thunk";
import StatusDropdown from "Common/Components/StatusDropdown/statusDropdown";
import { DynamicMenuItem } from "Common/Components/DynamicActionMenu/DynamicActionMenu";
import RestoreIcon from "@mui/icons-material/Restore";
import VisibilityIcon from "@mui/icons-material/Visibility";
import NameWithDate from "Common/Components/NameWithDate.tsx/NameWithDate";
import FormattedDate from "Common/Components/NameWithDate.tsx/FormattedDate";

interface EnquiryPageProps {
  type: "product" | "service";
}

const EnquiryJunkPage: React.FC<EnquiryPageProps> = ({ type }) => {
  const dispatch = useDispatch<any>();
  const activeType = type; // product by default

  const addButtonLabel =
    activeType === "product"
      ? "Create Product Enquiry"
      : "Create Service Enquiry";

  const addRoute =
    activeType === "product"
      ? `/enquiry/add-product-enquiry`
      : `/enquiry/add-services-enquiry`;

  const navigate = useNavigate();

  const handleView = (enquiryId: string) => {
    navigate(`/enquiry/${activeType}/enquiry_log/view/${enquiryId}`);
  };

  const handleRestore = async (enquiryId: string) => {
    try {
      const resData = dispatch(
        handleProductEnquiryStatus({
          id: enquiryId,
          enquiry_stage: "enquiry_log",
        })
      ).unwrap();
      if (resData) {
        // toast.success("Enquiry Restored Successfully")
        navigate(`/enquiry/${activeType}/enquiry_log`);
      }
    } catch (err) {}
  };

  const getColumns = () => {
    const commonColumns = [
      {
        header: "Sr. No.",
        accessorKey: "sr_no",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row, table }: { row: any; table: any }) =>
          table.getState().pagination.pageIndex *
            table.getState().pagination.pageSize +
          row.index +
          1,
      },
      {
        header: "Enquiry No.",
        accessorKey: "enquiry_number",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "dropdown" as const,
        filterFetchUrl: `/enquiry/${activeType}/dynamic_dropdown/enquiry_number?stage=junk`,
      },
      {
        header: "Enquiry Date",
        accessorKey: "enquiry_date",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "date" as const,
        filterFetchUrl: `/enquiry/${activeType}/dynamic_dropdown/enquiry_date?stage=junk`,
        cell: ({ row }: { row: any }) => (
          <FormattedDate date={row.original.enquiry_date} />
        ),
      },
      {
        header: "Received Date",
        accessorKey: "received_date",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "date" as const,
        filterFetchUrl: `/enquiry/${activeType}/dynamic_dropdown/received_data?stage=junk`,
        cell: ({ row }: { row: any }) => (
          <FormattedDate date={row.original.received_date} />
        ),
      },
      {
        header: "Customer Name",
        accessorKey: "company_name",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "dropdown" as const,
        filterFetchUrl: `/enquiry/${activeType}/dynamic_dropdown/company_name?stage=junk`,
      },
      {
        header: "Source of Enquiry",
        accessorKey: "source_of_enquiry",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "dropdown" as const,
        filterFetchUrl: `/enquiry/${activeType}/dynamic_dropdown/source_of_enquiry?stage=junk`,
      },
      {
        header: "Agent",
        accessorKey: "agent_name",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "dropdown" as const,
        filterFetchUrl: `/enquiry/${activeType}/dynamic_dropdown/agent?stage=junk`,
        cell: ({ row }: { row: any }) =>
          row.original.agent?.agent_name || "N/A",
      },
      {
        header: "Reference",
        accessorKey: "reference",
        enableColumnFilter: false,
        enableSorting: true,
      },
      // {
      //   header: "Items",
      //   accessorKey: "item_name",
      //   enableColumnFilter: true,
      //   enableSorting: true,
      //   filterType: "dropdown" as const,
      //   filterFetchUrl: "enquiry/product/dynamic_dropdown/items__item__item_name",
      //   cell: ({ row }: { row: any }) => {
      //     const itemDetails = row.original.item_details;
      //     if (Array.isArray(itemDetails) && itemDetails.length > 0) {
      //       return itemDetails.map((item: any) => item.item_name).join(", ");
      //     }
      //     return "N/A";
      //   }
      // },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "dropdown" as const,
        filterFetchUrl: `/enquiry/${activeType}/dynamic_dropdown/status?stage=junk`,
        // cell: ({ row }: { row: any }) => {
        //   return <StatusDropdown currentStatus={row.original.status} itemId={row.original.id} onStatusChange={handleStatusChange} statusOptions={enquiryStatusOptions} disabled={false} />
        // }
      },
      // {
      //   header: "EMD",
      //   accessorKey: "emd",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      // },
      //   {
      //   header: "Assigned To",
      //   accessorKey: "full_name",
      //   enableColumnFilter: true,
      //   enableSorting: true,
      //   filterType: "dropdown" as const,
      //   // filterFetchUrl: "/enquiry/dynamic_dropdown/status",
      //   cell: ({ row }: { row: any }) => {
      //     const Assigneddetails = row.original.assigned_member_details;
      //     if (Array.isArray(Assigneddetails) && Assigneddetails.length > 0) {
      //       return Assigneddetails.map((item: any) => item.full_name).join(", ");
      //     }
      //     return "N/A";
      //   }
      // },

      {
        header: "Notes",
        accessorKey: "notes",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Created By/Date",
        accessorKey: "created_at",
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => (
          <NameWithDate
            name={row.original.created_by_user}
            date={row.original.created_at}
          />
        ),
      },
      {
        header: "Updated By/Date",
        accessorKey: "updated_at",
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => (
          <NameWithDate
            name={row.original.updated_by_user}
            date={row.original.updated_at}
          />
        ),
      },
    ];

    const actionColumn = {
      header: "Action",
      cell: ({ row }: { row: any }) => {
        const enquiry_id = row.original.id;

        const actions = [
          {
            label: "Restore",
            icon: <RestoreIcon fontSize="small" color="success" />,
            onClick: () => handleRestore(enquiry_id),
          },
          {
            label: "View",
            icon: <VisibilityIcon fontSize="small" color="info" />,
            onClick: () => handleView(enquiry_id),
          },
        ];

        // return <ActionDropdown actions={actions} />;
        return <DynamicMenuItem row={row.original} menuItems={actions} />;
      },
    };

    return [...commonColumns, actionColumn];
  };

  return (
    <>
      <MasterListPage
        activeTab="junk"
        title={`${activeType === "product" ? "Product" : "Service"} Junk`}
        addButtonLabel={addButtonLabel}
        addRoute={addRoute}
        columns={getColumns()}
        statusToggleUrl={`/enquiry/${activeType}`}
        activeType={activeType}
      />
    </>
  );
};

export default EnquiryJunkPage;
